// extracted by mini-css-extract-plugin
export default {"App":"App_App__7iJoo","App_Code":"App_App_Code__uAFAA"};